const apis = [
    {
        code: "APP_LOGIN",
        uri: 'sys/login',
        method: 'post',
        mock: false,
        errorMessage: "登录失败",
        type: "action",
        title: "登录"
    },
    {
        code: "PRODUCER_QUERY",
        uri: "producer/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "PRODUCER_APPLY",
        uri: "producer/apply",
        method: "post",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "PRODUCER_DELETE",
        uri: "producer/delete",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "PRODUCER_EXECUTE",
        uri: "producer/execute",
        method: "get",
        mock: false,
        errorMessage: "执行失败",
        type: "query",
        title: "执行生产者"
    },
    {
        code: "PRODUCER_PAUSE",
        uri: "producer/pause",
        method: "get",
        mock: false,
        errorMessage: "暂停失败",
        type: "query",
        title: "暂停生产者"
    },
    {
        code: "PRODUCER_RESUME",
        uri: "producer/resume",
        method: "get",
        mock: false,
        errorMessage: "恢复失败",
        type: "query",
        title: "恢复生产者"
    },
    {
        code: "PRODUCER_DETAIL",
        uri: "producer/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "生产者详情"
    },
    {
        code: "PRODUCER_BUSINESS_FIELD",
        uri: "producer/businessField",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "获取字段"
    },
    {
        code: "CONSUMER_QUERY",
        uri: "consumer/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "CONSUMER_REPORT",
        uri: "consumer/report",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "CONSUMER_DETAIL",
        uri: "consumer/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "消费者详情"
    },
    {
        code: "CONSUMER_UPDATE_THREAD",
        uri: "consumer/setThread",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "action",
        title: "查询实时数据"
    },
    {
        code: "CONSUMER_APPLY",
        uri: "consumer/apply",
        method: "post",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "CONSUMER_DELETE",
        uri: "consumer/delete",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "CONSUMER_PAUSE",
        uri: "consumer/pause",
        method: "get",
        mock: false,
        errorMessage: "暂停失败",
        type: "query",
        title: "暂停消费者"
    },
    {
        code: "CONSUMER_RESUME",
        uri: "consumer/resume",
        method: "get",
        mock: false,
        errorMessage: "恢复失败",
        type: "query",
        title: "恢复消费者"
    },
    {
        code: "THREAD_QUERY",
        uri: "thread/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "PRODUCER_LOG_QUERY",
        uri: "log/producer/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "PRODUCER_LOG_DETAIL",
        uri: "log/producer/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "PRODUCER_LOG_DETAIL_BY_REQUESTID",
        uri: "log/producer/detailByRequestId",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "生产者详情"
    },
    {
        code: "CONSUMER_LOG_QUERY",
        uri: "log/consumer/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "CONSUMER_LOG_DETAIL",
        uri: "log/consumer/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "CONSUMER_LOG_RETRY",
        uri: "log/consumer/retry",
        method: "get",
        mock: false,
        errorMessage: "重试失败",
        type: "action",
        title: "重试"
    },
    {
        code: "CONSUMER_BUSINESS_FIELD",
        uri: "consumer/businessField",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "获取字段"
    },
    {
        code: "QUEUE_QUERY",
        uri: "queue/queryAllQueue",
        method: "post",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "THREAD_POOL_QUERY",
        uri: "threadpool/query",
        method: "get",
        mock: true,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "TABLE_QUERY",
        uri: "database/table",
        method: "get",
        mock: true,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "SUMMARY_QUERY",
        uri: "log/summary.php",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "DAY_QUERY",
        uri: "log/day.php",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "MALL_QUERY",
        uri: "mall/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "MALL_DETAIL",
        uri: "mall/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "MALL_APPLY",
        uri: "mall/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "MALL_DELETE",
        uri: "mall/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "MALL_API_QUERY",
        uri: "mall/api/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "MALL_API_APPLY",
        uri: "mall/api/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "MALL_API_DELETE",
        uri: "mall/api/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "ROUTING_QUERY",
        uri: "routing/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询站点"
    },
    {
        code: "ROUTING_APPLY",
        uri: "routing/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "action",
        title: "保存站点"
    },
    {
        code: "ROUTING_DELETE",
        uri: "routing/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除站点"
    },
    {
        code: "ROUTING_DETAIL",
        uri: "routing/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询详情"
    },
    {
        code: "ROUTING_LOCATION_QUERY",
        uri: "routing/location/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询站点"
    },
    {
        code: "ROUTING_LOCATION_DETAIL",
        uri: "routing/location/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询站点"
    },
    {
        code: "ROUTING_LOCATION_APPLY",
        uri: "routing/location/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "action",
        title: "保存站点"
    },
    {
        code: "ROUTING_LOCATION_DELETE",
        uri: "routing/location/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除站点"
    },
    {
        code: "LOCATION_MODE",
        uri: "routing/location/mode",
        method: "get",
        mock: false,
        errorMessage: "操作失败",
        type: "action",
        title: "更新路由模式"
    },
    {
        code: "LOCATION_LOG_QUERY",
        uri: "log/location/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "LOCATION_LOG_DETAIL",
        uri: "log/location/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询实时数据"
    },
    {
        code: "EXPRESSION_EXECUTE",
        uri: "expression/execute",
        method: "post",
        mock: false,
        errorMessage: "执行失败",
        type: "action",
        title: "执行表达式"
    },

    {
        code: "USER_QUERY",
        uri: "fnd/user/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询用户数据"
    },
    {
        code: "USER_DETAIL",
        uri: "fnd/user/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询用户数据"
    },
    {
        code: "USER_APPLY",
        uri: "fnd/user/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "action",
        title: "保存用户数据"
    },
    {
        code: "USER_DELETE",
        uri: "fnd/user/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除用户数据"
    },
    {
        code: "ROLE_QUERY",
        uri: "fnd/role/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询角色数据"
    },
    {
        code: "ROLE_DETAIL",
        uri: "fnd/role/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询角色数据"
    },
    {
        code: "ROLE_APPLY",
        uri: "fnd/role/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "action",
        title: "保存角色数据"
    },
    {
        code: "ROLE_DELETE",
        uri: "fnd/role/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除角色数据"
    },
    {
        code: "ROLE_USER_ADD",
        uri: "fnd/role/user/add",
        method: "post",
        mock: false,
        errorMessage: "添加成员失败",
        type: "action",
        title: "添加角色成员"
    },
    {
        code: "ROLE_USER_REMOVE",
        uri: "fnd/role/user/remove",
        method: "get",
        mock: false,
        errorMessage: "删除成员失败",
        type: "action",
        title: "删除角色成员"
    },
    {
        code: "ROLE_USER_LIST",
        uri: "fnd/role/user/list",
        method: "get",
        mock: false,
        errorMessage: "查询成员失败",
        type: "query",
        title: "查询角色成员"
    },
    {
        code: "USER_ROLE_LIST",
        uri: "fnd/user/role/list",
        method: "get",
        mock: false,
        errorMessage: "查询成员失败",
        type: "query",
        title: "查询角色成员"
    },
    {
        code: "MENU_QUERY",
        uri: "fnd/menu/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询菜单数据"
    },
    {
        code: "MENU_DETAIL",
        uri: "fnd/menu/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询角菜单数据"
    },
    {
        code: "MENU_APPLY",
        uri: "fnd/menu/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "action",
        title: "保存菜单数据"
    },
    {
        code: "MENU_DELETE",
        uri: "fnd/menu/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除菜单数据"
    },
    {
        code: "PERMISSION_QUERY",
        uri: "fnd/permission/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询权限组数据"
    },
    {
        code: "PERMISSION_DETAIL",
        uri: "fnd/permission/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询权限组数据"
    },
    {
        code: "PERMISSION_APPLY",
        uri: "fnd/permission/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "action",
        title: "保存权限组数据"
    },
    {
        code: "PERMISSION_DELETE",
        uri: "fnd/permission/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除权限组数据"
    },
    {
        code: "PERMISSION_ITEM_QUERY",
        uri: "fnd/permission/item/list",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询权限组数据"
    },
    {
        code: "PERMISSION_ITEM_APPLY",
        uri: "fnd/permission/item/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "action",
        title: "保存权限组数据"
    },
    {
        code: "PERMISSION_ITEM_REMOVE",
        uri: "fnd/permission/item/remove",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除权限组数据"
    },
    {
        code: "REST_QUERY",
        uri: "fnd/rest/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询接口数据"
    },
    {
        code: "REST_DETAIL",
        uri: "fnd/rest/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询接口数据"
    },
    {
        code: "REST_APPLY",
        uri: "fnd/rest/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "action",
        title: "保存接口数据"
    },
    {
        code: "REST_DELETE",
        uri: "fnd/rest/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除接口数据"
    },
    {
        code: "REST_REFRESH",
        uri: "fnd/rest/refresh",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询接口数据"
    },
    {
        code: "REST_CHANGE_LEVEL",
        uri: "fnd/rest/changeLevel",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "action",
        title: "查询接口数据"
    },

    {
        code: "FILE_QUERY",
        uri: "fnd/file/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询文件数据"
    },
    {
        code: "FILE_DETAIL",
        uri: "fnd/file/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询文件数据"
    },
    {
        code: "FILE_APPLY",
        uri: "fnd/file/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "action",
        title: "保存文件数据"
    },
    {
        code: "FILE_UPLOAD",
        uri: "fnd/file/upload",
        method: "post",
        mock: false,
        errorMessage: "上传失败",
        type: "action",
        title: "上传文件"
    },
    {
        code: "FILE_DELETE",
        uri: "fnd/file/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除文件数据"
    },
    {
        code: "SYS_USER_PROFILE",
        uri: "system/user/profile",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "query",
        title: "删除文件数据"
    },
    {
        code: "SEAL_QUERY",
        uri: "seal/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询公章数据"
    },
    {
        code: "SEAL_LOV",
        uri: "seal/lov",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询公章数据"
    },
    {
        code: "SEAL_DETAIL",
        uri: "seal/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询公章数据"
    },
    {
        code: "SEAL_APPLY",
        uri: "seal/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "action",
        title: "保存公章数据"
    },
    {
        code: "SEAL_DELETE",
        uri: "seal/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除公章数据"
    },

    {
        code: "TEMPLATE_QUERY",
        uri: "template/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询模板数据"
    },
    {
        code: "TEMPLATE_LOV_QUERY",
        uri: "template/lov",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询模板数据"
    },
    {
        code: "TEMPLATE_DETAIL",
        uri: "template/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询模板数据"
    },
    {
        code: "TEMPLATE_APPLY",
        uri: "template/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "action",
        title: "保存模板数据"
    },
    {
        code: "TEMPLATE_DELETE",
        uri: "template/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除模板数据"
    },

    {
        code: "DOC_QUERY",
        uri: "doc/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询公文数据"
    },
    {
        code: "DOC_HISTORY_QUERY",
        uri: "doc/history",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询公文数据"
    },
    {
        code: "DOC_DETAIL",
        uri: "doc/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询公文数据"
    },
    {
        code: "DOC_APPLY",
        uri: "doc/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "action",
        title: "保存公文数据"
    },
    {
        code: "DOC_PREVIEW",
        uri: "doc/preview",
        method: "post",
        mock: false,
        errorMessage: "预览失败",
        type: "action",
        title: "预览公文数据"
    },
    {
        code: "DOC_DOWNLOAD",
        uri: "doc/download",
        method: "get",
        mock: false,
        errorMessage: "下载失败",
        type: "action",
        title: "下载pdf"
    },
    {
        code: "DOC_UPDATE_STYLE",
        uri: "doc/updateStyle",
        method: "post",
        mock: false,
        errorMessage: "更新失败",
        type: "action",
        title: "更新样式数据"
    },
    {
        code: "DOC_DELETE",
        uri: "doc/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除公文数据"
    },
    {
        code: "DOC_CONTENT_UPLOAD",
        uri: "doc/upload",
        method: "post",
        mock: false,
        errorMessage: "上传失败",
        type: "action",
        title: "上传正文附件"
    },
    {
        code: "DOC_HTML_CONVERT",
        uri: "doc/convert",
        method: "post",
        mock: false,
        errorMessage: "上传失败",
        type: "action",
        title: "上传正文附件"
    },
    {
        code: "DOC_DOWNLOAD_WORD",
        uri: "doc/downloadWord",
        method: "get",
        mock: false,
        errorMessage: "下载失败",
        type: "query",
        title: "下载word"
    },
    {
        code: "DOC_SHORT_HTML",
        uri: "doc/shortHtml",
        method: "post",
        mock: false,
        errorMessage: "下载失败",
        type: "action",
        title: "下载word"
    },
    {
        code: "ATTACH_QUERY",
        uri: "attachment/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询附件数据"
    },
    {
        code: "ATTACH_DETAIL",
        uri: "attachment/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询附件数据"
    },
    {
        code: "ATTACH_APPLY",
        uri: "attachment/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "action",
        title: "保存附件数据"
    },
    {
        code: "ATTACH_DELETE",
        uri: "attachment/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除附件数据"
    },
    {
        code: "ATTACH_DESC_QUERY",
        uri: "attachment/getAttachmentDesc",
        method: "get",
        mock: false,
        errorMessage: "请求失败",
        type: "query",
        title: "请求附件描述信息"
    },
    {
        code: "ATTACH_DESC_UPDATE",
        uri: "attachment/updateAttachmentDesc",
        method: "post",
        mock: false,
        errorMessage: "更新失败",
        type: "action",
        title: "更新附件描述信息"
    },
    {
        code: "TEMPLATE_DOC_NO_QUERY",
        uri: "template/doc-no/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询模板当前发文字号"
    },
    {
        code: "BPM_TODO_QUERY",
        uri: "bpm/todo",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询公文数据"
    },
    {
        code: "BPM_EMPLOYEE_QUERY",
        uri: "bpm/query/employee",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询公文数据"
    },
    {
        code: "DOC_SUBMIT",
        uri: "doc/submit",
        method: "post",
        mock: false,
        errorMessage: "查询失败",
        type: "action",
        title: "查询公文数据"
    },
    {
        code: "BPM_REQUEST",
        uri: "bpm/request",
        method: "post",
        mock: false,
        errorMessage: "操作失败",
        type: "action",
        title: "操纵失败"
    },
    {
        code: "BPM_REJECT_SUBMMITER",
        uri: "bpm/rejectToSubmitter",
        method: "post",
        mock: false,
        errorMessage: "操作失败",
        type: "action",
        title: "操纵失败"
    },
    {
        code: "BPM_TERMINATE",
        uri: "bpm/terminate",
        method: "post",
        mock: false,
        errorMessage: "操作失败",
        type: "action",
        title: "操纵失败"
    },
    {
        code: "BPM_COMPLETE",
        uri: "bpm/complete",
        method: "post",
        mock: false,
        errorMessage: "操作失败",
        type: "action",
        title: "操纵失败"
    },
    {
        code: "BPM_RESUBMIT",
        uri: "bpm/resubmit",
        method: "post",
        mock: false,
        errorMessage: "操作失败",
        type: "action",
        title: "操纵失败"
    },
    {
        code: "BPM_APPROVE",
        uri: "bpm/approve",
        method: "post",
        mock: false,
        errorMessage: "操作失败",
        type: "action",
        title: "操纵失败"
    },
    {
        code: "BPM_REPLY",
        uri: "bpm/reply",
        method: "post",
        mock: false,
        errorMessage: "操作失败",
        type: "action",
        title: "操纵失败"
    },
    {
        code: "BPM_TASK_DETAIL",
        uri: "bpm/task/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询失败"
    },
    {
        code: "BPM_HISTORY",
        uri: "bpm/history",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "get",
        title: "查询失败"
    },
    {
        code: "TEMPLATE_QUERY_NEXT_DOC_NO",
        uri: "template/queryNextDocNo",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "get",
        title: "查询失败"
    },
    {
        code: "DOC_UPDATE_DOC_NO",
        uri: "doc/updateDocNo",
        method: "post",
        mock: false,
        errorMessage: "操作失败",
        type: "action",
        title: "操纵失败"
    },
    {
        code: "DOC_CONTENT_HTML",
        uri: "doc/contentHtml",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询失败"
    },
    {
        code: "DOC_CONTENT_HTML_UPDATE",
        uri: "doc/updateContentHtml",
        method: "post",
        mock: false,
        errorMessage: "查询失败",
        type: "action",
        title: "查询失败"
    },
    {
        code: "DOC_CONTENT_EDIT_PARAM",
        uri: "doc/contentWordEditParam",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询失败"
    },
    {
        code: "REMARK_QUERY",
        uri: "remark/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询意见数据"
    },
    {
        code: "REMARK_DETAIL",
        uri: "remark/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询意见数据"
    },
    {
        code: "REMARK_APPLY",
        uri: "remark/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "action",
        title: "保存用户数据"
    },
    {
        code: "CONTENT_PREVIEW",
        uri: "doc/contentPreview",
        method: "post",
        mock: false,
        errorMessage: "预览失败",
        type: "action",
        title: "预览正文"
    },
    {
        code: "REMARK_DELETE",
        uri: "remark/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除意见数据"
    },
    {
        code: "MEETING_REMARK_QUERY",
        uri: "meetingRemark/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询意见数据"
    },
    {
        code: "MEETING_REMARK_DETAIL",
        uri: "meetingRemark/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询意见数据"
    },
    {
        code: "MEETING_REMARK_APPLY",
        uri: "meetingRemark/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "action",
        title: "保存用户数据"
    },
    {
        code: "CONTENT_PREVIEW",
        uri: "doc/contentPreview",
        method: "post",
        mock: false,
        errorMessage: "预览失败",
        type: "action",
        title: "预览正文"
    },
    {
        code: "MEETING_REMARK_DELETE",
        uri: "meetingRemark/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除意见数据"
    },
    {
        code: "DOC_TEMPLATE_DETAIL",
        uri: "template/v2/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询意见数据"
    },
    {
        code: "DOC_TEMPLATE_HTML",
        uri: "template/v2/html",
        method: "post",
        mock: false,
        errorMessage: "查询失败",
        type: "action",
        title: "查询意见数据"
    },
    {
        code: "CONTAINER_IMPORT",
        uri: "container/import",
        method: "get",
        mock: false,
        errorMessage: "上传失败",
        type: "action",
        title: "上传EPL"
    },
    {
        code: "BOX_IMPORT",
        uri: "box/import",
        method: "get",
        mock: false,
        errorMessage: "上传失败",
        type: "action",
        title: "上传EPL"
    },
    {
        code: "CONTAINER_QUERY",
        uri: "container/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询装箱数据"
    },
    {
        code: "BOX_QUERY",
        uri: "box/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询装箱数据"
    },
    {
        code: "ORDER_QUERY",
        uri: "box/order/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询装箱数据"
    },
    {
        code: "CONTAINER_DETAIL",
        uri: "container/detail",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询装箱数据"
    },
    {
        code: "CONTAINER_APPLY",
        uri: "container/apply",
        method: "post",
        mock: false,
        errorMessage: "保存失败",
        type: "action",
        title: "保存装箱数据"
    },
    {
        code: "CONTAINER_STATUS_CHANGE",
        uri: "container/changeStatus",
        method: "get",
        mock: false,
        errorMessage: "更改状态失败",
        type: "action",
        title: "更改状态"
    },
    {
        code: "CONTAINER_DELETE",
        uri: "container/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除装箱数据"
    },
    {
        code: "BOX_DELETE",
        uri: "box/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除装箱数据"
    },
    {
        code: "ORDER_DELETE",
        uri: "order/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除装箱数据"
    },
    {
        code: "ORDER_DETAIL",
        uri: "order/detail",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除装箱数据"
    },
    {
        code: "MATERIAL_QUERY",
        uri: "material/queryByContainerId",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询装箱数据"
    },
    {
        code: "MATERIAL_SET_MIX_NUMBER",
        uri: "material/setMixNumber",
        method: "post",
        mock: false,
        errorMessage: "更改编码失败",
        type: "action",
        title: "更改编码"
    },
    {
        code: "RECORD_QUERY",
        uri: "record/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询装箱数据"
    },
    {
        code: "SIZE_IMPORT",
        uri: "size/import",
        method: "get",
        mock: false,
        errorMessage: "上传失败",
        type: "action",
        title: "上传EPL"
    },
    {
        code: "REGULAR_CODE_IMPORT",
        uri: "regular/import",
        method: "get",
        mock: false,
        errorMessage: "上传失败",
        type: "action",
        title: "上传EPL"
    },
    {
        code: "SIZE_PACKING_QUERY",
        uri: "size/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询装箱数据"
    },
    {
        code: "SIZE_PACKING_DELETE",
        uri: "size/delete",
        method: "get",
        mock: false,
        errorMessage: "删除失败",
        type: "action",
        title: "删除装箱数据"
    },

    {
        code: "SIZE_PACKING_LIST_QUERY",
        uri: "size/packingList",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询装箱数据"
    },
    {
        code: "BOX_PIECE_QUERY",
        uri: "box/piece/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询装箱数据"
    },
    {
        code: "CONTAINER_UPDATE",
        uri: "container/update",
        method: "post",
        mock: false,
        errorMessage: "更改编码失败",
        type: "action",
        title: "更改编码"
    },
    {
        code: "MIX_CODE_IMPORT",
        uri: "mixCode/import",
        method: "get",
        mock: false,
        errorMessage: "上传失败",
        type: "action",
        title: "上传EPL"
    },
    {
        code: "MIX_CODE_QUERY",
        uri: "mixCode/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询装箱数据"
    },
    {
        code: "REGULAR_QUERY",
        uri: "regular/query",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询常规码数据"
    },
    {
        code: "BOX_REPACKING",
        uri: "box/repacking",
        method: "post",
        mock: false,
        errorMessage: "翻箱失败",
        type: "action",
        title: "翻箱"
    },
    {
        code: "NO_SCAN_BARCODE_QUERY",
        uri: "box/getNoScanCode",
        method: "get",
        mock: false,
        errorMessage: "查询失败",
        type: "query",
        title: "查询装箱数据"
    },
]

export default apis;
